import EmptyState from '../components/EmptyState';

export default function Phonics() {
  return (
    <EmptyState
      title="Phonics"
      description="Phonics reference data and pronunciation guides"
    />
  );
}
